import { TrendingUp, Clock, DollarSign, Receipt, BarChart2, Users } from 'lucide-react';

const PLANNED_FEATURES = [
  { icon: Users, title: 'Employee Advance Management', desc: 'Track cash advances allotted to each employee, repayment schedules, and outstanding balances.' },
  { icon: TrendingUp, title: 'Department Expense Tracking', desc: 'Monitor and categorize spending by department with budget vs actual comparisons.' },
  { icon: Receipt, title: 'Expense Claims & Approvals', desc: 'Staff submits expense claims, managers approve or reject with comments, finance processes reimbursement.' },
  { icon: DollarSign, title: 'Khata / Financial Ledger', desc: 'Company-wide financial ledger view with debit/credit entries, vendor payments, and reconciliation.' },
  { icon: BarChart2, title: 'Analytics & Reports', desc: 'Expense trends, top spenders, category breakdowns, and monthly/quarterly expense reports.' },
];

export default function ExpensePage() {
  return (
    <div className="flex flex-col items-center justify-start py-12 px-4 fade-in">
      <div className="w-full max-w-[600px] space-y-8">
        {/* Header */}
        <div className="text-center">
          <div className="w-16 h-16 rounded-[20px] bg-[var(--accent)]/10 flex items-center justify-center mx-auto mb-4">
            <TrendingUp size={28} className="text-[var(--accent)]" />
          </div>
          <h1 className="text-[24px] font-bold text-[var(--text-primary)]">Financial Management</h1>
          <div className="flex items-center justify-center gap-2 mt-2">
            <Clock size={14} className="text-amber-500" />
            <span className="text-[13px] font-semibold text-amber-600 dark:text-amber-400">Coming Soon</span>
          </div>
          <p className="text-[13px] text-[var(--text-secondary)] mt-3 max-w-[420px] mx-auto">
            We're building a complete financial management suite for your organization. Here's what's coming:
          </p>
        </div>

        {/* Feature list */}
        <div className="space-y-3">
          {PLANNED_FEATURES.map(f => (
            <div key={f.title} className="card p-4 flex items-start gap-4">
              <div className="w-9 h-9 rounded-[10px] bg-[var(--accent)]/10 flex items-center justify-center shrink-0">
                <f.icon size={16} className="text-[var(--accent)]" />
              </div>
              <div>
                <p className="text-[13px] font-semibold text-[var(--text-primary)]">{f.title}</p>
                <p className="text-[12px] text-[var(--text-secondary)] mt-0.5">{f.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Footer note */}
        <div className="rounded-[12px] border border-[var(--border)] bg-[var(--bg-muted)] px-4 py-3 text-center">
          <p className="text-[12px] text-[var(--text-secondary)]">
            Until then, manage financial records manually or use the
            <span className="font-semibold text-[var(--accent)]"> Payroll module</span> for salary-related advances.
          </p>
        </div>
      </div>
    </div>
  );
}
